(() => {
  "use strict";

  const sections = document.querySelectorAll(
    ".srs-reservation",
  );

  if (!sections.length) return;

  const escapeHtml = (value) => {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  };

  const formatPrice = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) return "";

    return new Intl.NumberFormat("ja-JP").format(
      number,
    );
  };

  const getStateManager = () => {
    return window.SRS?.state || null;
  };

  const getProductBadges = (product) => {
    if (Array.isArray(product.badges)) {
      return product.badges
        .map((badge) => String(badge ?? "").trim())
        .filter(Boolean)
        .slice(0, 4);
    }

    // Compatibility fallback for an older srs-products deployment.
    const badges = [];

    if (product.product_type === "seat_only") badges.push("お席のみ");
    if (product.product_type === "hotpot") badges.push("鍋料理");
    if (product.product_type === "course") badges.push("コース料理");
    if (product.reservation_required) badges.push("要予約");

    if (
      Number.isInteger(product.minimum_days_before) &&
      product.minimum_days_before > 0
    ) {
      badges.push(`${product.minimum_days_before}日前まで`);
    }

    if (
      product.allows_drink_plan &&
      product.drink_plan_price_per_person !== null &&
      product.drink_plan_price_per_person !== undefined
    ) {
      badges.push("飲み放題追加可");
    }

    return badges.slice(0, 4);
  };

  const createQuantityHtml = (
    product,
    inputId,
  ) => {
    if (product.product_type !== "hotpot") {
      return "";
    }

    const maximumQuantity =
      Number.isInteger(product.max_quantity) &&
      product.max_quantity > 0
        ? product.max_quantity
        : 9;

    return `
      <div
        class="srs-reservation__quantity-panel"
        data-quantity-panel="${escapeHtml(inputId)}"
        hidden
      >
        <div class="srs-reservation__quantity-row">
          <div>
            <p class="srs-reservation__quantity-title">
              鍋数
            </p>

            <p class="srs-reservation__quantity-description">
              ご希望の鍋数をお選びください。
            </p>
          </div>

          <div
            class="srs-reservation__quantity-control"
            aria-label="鍋数"
          >
            <button
              type="button"
              class="srs-reservation__quantity-button"
              data-quantity-action="decrease"
              aria-label="鍋数を減らす"
            >
              −
            </button>

            <span
              class="srs-reservation__quantity-value"
              data-quantity-value
              data-min="1"
              data-max="${maximumQuantity}"
              data-current="1"
              aria-live="polite"
            >
              1鍋
            </span>

            <button
              type="button"
              class="srs-reservation__quantity-button"
              data-quantity-action="increase"
              aria-label="鍋数を増やす"
            >
              ＋
            </button>
          </div>
        </div>

        <div class="srs-reservation__quantity-notice">
          <p>※1テーブルにつき、鍋料理は1種類までとなります。</p>
        </div>
      </div>
    `;
  };

  const createProductHtml = (
    product,
    sectionId,
    index,
  ) => {
    const inputId =
      `SrsProduct-${sectionId}-${index}`;

    const badges = getProductBadges(product)
      .map(
        (badge) => `
          <span class="srs-reservation__product-badge">
            ${escapeHtml(badge)}
          </span>
        `,
      )
      .join("");

    const priceHtml =
      product.price_per_person !== null &&
      product.price_per_person !== undefined
        ? `
          <p class="srs-reservation__product-price">
            ${formatPrice(
              product.price_per_person,
            )}円
            <small>／お一人様</small>
          </p>
        `
        : "";

    const drinkPlanOptionHtml =
        product.allows_drink_plan &&
        product.drink_plan_price_per_person !==
            null &&
        product.drink_plan_price_per_person !==
            undefined
            ? `
            <div
                class="srs-reservation__drink-plan"
                data-drink-plan-panel
                hidden
            >
                <label class="srs-reservation__drink-plan-label">
                <input
                    type="checkbox"
                    class="srs-reservation__drink-plan-input"
                    data-drink-plan-input
                    data-drink-plan-price="${
                    product.drink_plan_price_per_person
                    }"
                >

                <span class="srs-reservation__drink-plan-content">
                    <strong>
                    飲み放題を追加する
                    </strong>

                    <small>
                    お一人様 ＋${formatPrice(
                        product.drink_plan_price_per_person,
                    )}円
                    </small>
                </span>
                </label>
            </div>
            `
            : "";

    const maximumQuantity =
      Number.isInteger(product.max_quantity) &&
      product.max_quantity > 0
        ? product.max_quantity
        : 1;

    return `
      <div class="srs-reservation__product">
        <input
          id="${escapeHtml(inputId)}"
          class="srs-reservation__product-input"
          type="radio"
          name="srs-product-${escapeHtml(sectionId)}"
          value="${escapeHtml(product.product_code)}"
          data-product-name="${escapeHtml(
            product.product_name_ja,
          )}"
          data-product-type="${escapeHtml(
            product.product_type,
          )}"
          data-price-per-person="${
            product.price_per_person ?? ""
          }"
          data-allows-drink-plan="${
            product.allows_drink_plan
              ? "true"
              : "false"
          }"
          data-drink-plan-price="${
            product.drink_plan_price_per_person ??
            ""
          }"
          data-max-quantity="${maximumQuantity}"
          data-minimum-days-before="${Math.max(
            0,
            Number(product.minimum_days_before || 0),
          )}"
        >

        <label
          class="srs-reservation__product-label"
          for="${escapeHtml(inputId)}"
        >
          <div class="srs-reservation__product-top">
            <h3 class="srs-reservation__product-name">
              ${escapeHtml(
                product.product_name_ja,
              )}
            </h3>

            <span
              class="srs-reservation__product-check"
              aria-hidden="true"
            ></span>
          </div>

          ${
            product.description_ja
              ? `
                <p class="srs-reservation__product-description">
                  ${escapeHtml(
                    product.description_ja,
                  )}
                </p>
              `
              : ""
          }

          ${
            badges
              ? `
                <div class="srs-reservation__product-meta">
                  ${badges}
                </div>
              `
              : ""
          }

          ${priceHtml}
        </label>

        ${createQuantityHtml(product, inputId)}
        ${drinkPlanOptionHtml}
      </div>
    `;
  };

  const hideAllQuantityPanels = (
    productList,
  ) => {
    productList
      .querySelectorAll(
        ".srs-reservation__quantity-panel",
      )
      .forEach((panel) => {
        panel.hidden = true;
      });
  };

  const hideAllDrinkPlanPanels = (
    productList,
    ) => {
    productList
        .querySelectorAll(
        "[data-drink-plan-panel]",
        )
        .forEach((panel) => {
        panel.hidden = true;

        const checkbox = panel.querySelector(
            "[data-drink-plan-input]",
        );

        if (checkbox) {
            checkbox.checked = false;
        }
        });
    };

  const updateQuantity = (
    quantityPanel,
    nextValue,
  ) => {
    const quantityValue =
      quantityPanel.querySelector(
        "[data-quantity-value]",
      );

    if (!quantityValue) return;

    const minimum = Number(
      quantityValue.dataset.min || 1,
    );

    const maximum = Number(
      quantityValue.dataset.max || 9,
    );

    const safeValue = Math.min(
      maximum,
      Math.max(minimum, Number(nextValue)),
    );

    quantityValue.dataset.current =
      String(safeValue);

    quantityValue.textContent =
      `${safeValue}鍋`;

    const decreaseButton =
      quantityPanel.querySelector(
        '[data-quantity-action="decrease"]',
      );

    const increaseButton =
      quantityPanel.querySelector(
        '[data-quantity-action="increase"]',
      );

    if (decreaseButton) {
      decreaseButton.disabled =
        safeValue <= minimum;
    }

    if (increaseButton) {
      increaseButton.disabled =
        safeValue >= maximum;
    }

    getStateManager()?.setProductQuantity(
      safeValue,
    );
  };

  const initializeQuantityControls = (
    productList,
  ) => {
    productList
      .querySelectorAll(
        ".srs-reservation__quantity-button",
      )
      .forEach((button) => {
        button.addEventListener("click", () => {
          const quantityPanel =
            button.closest(
              ".srs-reservation__quantity-panel",
            );

          if (!quantityPanel) return;

          const quantityValue =
            quantityPanel.querySelector(
              "[data-quantity-value]",
            );

          if (!quantityValue) return;

          const currentValue = Number(
            quantityValue.dataset.current || 1,
          );

          if (
            button.dataset.quantityAction ===
            "increase"
          ) {
            updateQuantity(
              quantityPanel,
              currentValue + 1,
            );
          }

          if (
            button.dataset.quantityAction ===
            "decrease"
          ) {
            updateQuantity(
              quantityPanel,
              currentValue - 1,
            );
          }
        });
      });
  };

  const initializeDrinkPlanControls = (
    productList,
    ) => {
    productList
        .querySelectorAll(
        "[data-drink-plan-input]",
        )
        .forEach((checkbox) => {
        checkbox.addEventListener(
            "change",
            () => {
            const state = getStateManager();

            if (!state) return;

            const currentProduct =
                state.getState().product;

            state.setProduct({
                ...currentProduct,
                drinkPlanSelected:
                checkbox.checked,
                drinkPlanPricePerPerson:
                Number(
                    checkbox.dataset
                    .drinkPlanPrice || 0,
                ),
            });
            },
        );
        });
    };

  const initializeProductSelection = (
    productList,
    nextButton,
  ) => {
    productList
      .querySelectorAll(
        ".srs-reservation__product-input",
      )
      .forEach((input) => {
        input.addEventListener("change", () => {
            hideAllQuantityPanels(productList);
            hideAllDrinkPlanPanels(productList);

          const productType =
            input.dataset.productType || "";

          const pricePerPerson =
            input.dataset.pricePerPerson === ""
              ? null
              : Number(
                  input.dataset.pricePerPerson,
                );

          const drinkPlanPrice =
            input.dataset.drinkPlanPrice === ""
              ? null
              : Number(
                  input.dataset.drinkPlanPrice,
                );

          getStateManager()?.setProduct({
            code: input.value,
            name:
              input.dataset.productName || "",
            type: productType,
            quantity: 1,
            pricePerPerson,
            drinkPlanSelected: false,
            drinkPlanPricePerPerson:
              drinkPlanPrice,
            minimumDaysBefore: Math.max(
              0,
              Number(
                input.dataset.minimumDaysBefore || 0,
              ),
            ),
          });

          if (productType === "hotpot") {
            const productCard = input.closest(
                ".srs-reservation__product",
            );

            const quantityPanel =
                productCard?.querySelector(
                ".srs-reservation__quantity-panel",
                );

            if (quantityPanel) {
                quantityPanel.hidden = false;

                updateQuantity(
                quantityPanel,
                Number(
                    quantityPanel.querySelector(
                    "[data-quantity-value]",
                    )?.dataset.current || 1,
                ),
                );
            }
            }

            const allowsDrinkPlan =
            input.dataset.allowsDrinkPlan === "true";

            if (allowsDrinkPlan) {
            const productCard = input.closest(
                ".srs-reservation__product",
            );

            const drinkPlanPanel =
                productCard?.querySelector(
                "[data-drink-plan-panel]",
                );

            if (drinkPlanPanel) {
                drinkPlanPanel.hidden = false;
            }
            }
            

          nextButton.disabled = false;
          nextButton.classList.add(
            "is-enabled",
          );

          nextButton.textContent =
            "日時を選択する";
        });
      });
  };

    const renderGuestSelector = (section) => {
        const state = getStateManager();

        if (!state) return;

        const guests = state.getState().guests;

        const totalGuests =
          Number(guests.adults || 0) +
          Number(guests.children || 0);

        const maximumPartySize = 10;

        ["adults", "children"].forEach((type) => {
            const valueElement = section.querySelector(
            `[data-guest-value="${type}"]`,
            );

            const decreaseButton = section.querySelector(
            `[data-guest-action="decrease"][data-guest-type="${type}"]`,
            );

            const increaseButton = section.querySelector(
            `[data-guest-action="increase"][data-guest-type="${type}"]`,
            );

            const value = Number(guests[type] || 0);
            const minimum = type === "adults" ? 1 : 0;
            const maximum = 20;

            if (valueElement) {
            valueElement.textContent = `${value}名`;
            }

            if (decreaseButton) {
            decreaseButton.disabled = value <= minimum;
            }

            if (increaseButton) {
              increaseButton.disabled =
                totalGuests >= maximumPartySize;
            }
        });
        };

        const initializeGuestSelection = (section) => {
        const guestSelector = section.querySelector(
            "[data-guest-selector]",
        );

        const state = getStateManager();

        if (!guestSelector || !state) return;

        renderGuestSelector(section);

        guestSelector.addEventListener("click", (event) => {
            const button = event.target.closest(
            "[data-guest-action][data-guest-type]",
            );

            if (!button || button.disabled) return;

            const type = button.dataset.guestType;
            const action = button.dataset.guestAction;

            if (!["adults", "children"].includes(type)) {
            return;
            }

            const currentGuests = state.getState().guests;

            const totalGuests =
              Number(currentGuests.adults || 0) +
              Number(currentGuests.children || 0);

            const maximumPartySize = 10;

            if (
              action === "increase" &&
              totalGuests >= maximumPartySize
            ) {
              return;
            }

            const currentValue = Number(
            currentGuests[type] || 0,
            );

            const minimum = type === "adults" ? 1 : 0;
            const maximum = 20;

            let nextValue =
            action === "increase"
                ? currentValue + 1
                : currentValue - 1;

            nextValue = Math.min(
            maximum,
            Math.max(minimum, nextValue),
            );

            state.setGuests({
            [type]: nextValue,
            });

            renderGuestSelector(section);
        });
        };

        const initializeCustomerForm = (section) => {
            const state = getStateManager();

            if (!state) return;

            const nameInput = section.querySelector(
                "[data-customer-name]",
            );

            const phoneInput = section.querySelector(
                "[data-customer-phone]",
            );

            const emailInput = section.querySelector(
                "[data-customer-email]",
            );

            const preorderInput = section.querySelector(
                "[data-customer-preorder]",
            );

            const noteInput = section.querySelector(
                "[data-customer-note]",
            );

            if (
                !nameInput ||
                !phoneInput ||
                !emailInput ||
                !preorderInput ||
                !noteInput
            ) {
                return;
            }

            const updateCustomer = () => {
                state.setCustomer({
                name: nameInput.value,
                phone: phoneInput.value,
                email: emailInput.value,
                preorder: preorderInput.value,
                note: noteInput.value,
                });
            };

            [
                nameInput,
                phoneInput,
                emailInput,
                preorderInput,
                noteInput,
            ].forEach((input) => {
                input.addEventListener("input", updateCustomer);
            });

            updateCustomer();
            };

            const renderReservationSummary = (section) => {
                const state = getStateManager();

                if (!state) return;

                const summaryProduct = section.querySelector(
                    "[data-summary-product]",
                );

                const summaryQuantityRow =
                    section.querySelector(
                        "[data-summary-quantity-row]",
                    );

                    const summaryQuantity =
                    section.querySelector(
                        "[data-summary-quantity]",
                    );

                    const summaryDrinkPlanRow =
                    section.querySelector(
                        "[data-summary-drink-plan-row]",
                    );

                    const summaryDrinkPlan =
                    section.querySelector(
                        "[data-summary-drink-plan]",
                    );

                const summaryDate = section.querySelector(
                    "[data-summary-date]",
                );

                const summaryTime = section.querySelector(
                    "[data-summary-time]",
                );

                const summaryGuests = section.querySelector(
                    "[data-summary-guests]",
                );

                const data = state.getState();
                
                const isHotpot =
                    data.product.type === "hotpot";

                const hasDrinkPlan =
                    data.product.drinkPlanSelected === true;

                if (summaryProduct) {
                    summaryProduct.textContent =
                    data.product.name || "－";
                }

                if (summaryQuantityRow) {
                summaryQuantityRow.hidden = !isHotpot;
                }

                if (summaryQuantity && isHotpot) {
                summaryQuantity.textContent =
                    `${data.product.quantity}鍋`;
                }

                if (summaryDrinkPlanRow) {
                    summaryDrinkPlanRow.hidden =
                        !hasDrinkPlan;
                    }

                    if (
                    summaryDrinkPlan &&
                    hasDrinkPlan
                    ) {
                    summaryDrinkPlan.textContent =
                        `お一人様 ＋${formatPrice(
                        data.product
                            .drinkPlanPricePerPerson,
                        )}円`;
                    }

                if (summaryDate) {
                    summaryDate.textContent =
                    data.reservation.date || "－";
                }

                if (summaryTime) {
                    summaryTime.textContent =
                    data.reservation.time || "－";
                }

                if (summaryGuests) {
                    summaryGuests.textContent =
                    `大人 ${data.guests.adults}名 / 子ども ${data.guests.children}名`;
                }
                };

                const renderConfirmation = (section) => {
                    const state = getStateManager();

                    if (!state) return;

                    const product = section.querySelector(
                        "[data-confirmation-product]",
                    );

                    const quantityRow = section.querySelector(
                        "[data-confirmation-quantity-row]",
                    );

                    const quantity = section.querySelector(
                        "[data-confirmation-quantity]",
                    );

                    const drinkRow = section.querySelector(
                        "[data-confirmation-drink-row]",
                    );

                    const drink = section.querySelector(
                        "[data-confirmation-drink]",
                    );

                    const date = section.querySelector(
                        "[data-confirmation-date]",
                    );

                    const time = section.querySelector(
                        "[data-confirmation-time]",
                    );

                    const guests = section.querySelector(
                        "[data-confirmation-guests]",
                    );

                    const name = section.querySelector(
                        "[data-confirmation-name]",
                    );

                    const phone = section.querySelector(
                        "[data-confirmation-phone]",
                    );

                    const email = section.querySelector(
                        "[data-confirmation-email]",
                    );

                    const preorder = section.querySelector(
                        "[data-confirmation-preorder]",
                    );

                    const note = section.querySelector(
                        "[data-confirmation-note]",
                    );

                    const data = state.getState();

                    const isHotpot =
                        data.product.type === "hotpot";

                    const hasDrinkPlan =
                        data.product.drinkPlanSelected === true;

                    if (product) {
                        product.textContent =
                        data.product.name || "－";
                    }

                    if (quantityRow) {
                        quantityRow.hidden = !isHotpot;
                    }

                    if (quantity && isHotpot) {
                        quantity.textContent =
                        `${data.product.quantity}鍋`;
                    }

                    if (drinkRow) {
                        drinkRow.hidden = !hasDrinkPlan;
                    }

                    if (drink && hasDrinkPlan) {
                        drink.textContent =
                        `お一人様 ＋${formatPrice(
                            data.product
                            .drinkPlanPricePerPerson,
                        )}円`;
                    }

                    if (date) {
                        date.textContent =
                        data.reservation.date || "－";
                    }

                    if (time) {
                        time.textContent =
                        data.reservation.time || "－";
                    }

                    if (guests) {
                        guests.textContent =
                        `大人 ${data.guests.adults}名 ／ 子ども ${data.guests.children}名`;
                    }

                    if (name) {
                        name.textContent =
                        data.customer.name || "－";
                    }

                    if (phone) {
                        phone.textContent =
                        data.customer.phone || "－";
                    }

                    if (email) {
                        email.textContent =
                        data.customer.email || "未入力";
                    }

                    if (preorder) {
                        preorder.textContent =
                        data.customer.preorder || "なし";
                    }

                    if (note) {
                        note.textContent =
                        data.customer.note || "なし";
                    }
                    };


            const initializeReservationSubmit = (section) => {
                const submitButton = section.querySelector(
                    "[data-reservation-submit]",
                );

                const state = getStateManager();

                if (!submitButton || !state) return;

                const showError = (message) => {
                    const errorElement = section.querySelector(
                        '[data-srs-step-error="6"]',
                    );

                    if (errorElement) {
                        errorElement.textContent = message;
                        errorElement.hidden = false;
                        errorElement.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                        return;
                    }

                    alert(message);
                };

                const showSlotFullDialog = () =>
                    new Promise((resolve) => {
                        const existing = document.querySelector('[data-srs-slot-full-dialog]');
                        existing?.remove();

                        const backdrop = document.createElement('div');
                        backdrop.dataset.srsSlotFullDialog = 'true';
                        backdrop.setAttribute('role', 'dialog');
                        backdrop.setAttribute('aria-modal', 'true');
                        backdrop.style.cssText = [
                            'position:fixed', 'inset:0', 'z-index:2147483000',
                            'display:flex', 'align-items:center', 'justify-content:center',
                            'padding:20px', 'background:rgba(28,20,14,.58)'
                        ].join(';');

                        const panel = document.createElement('div');
                        panel.style.cssText = [
                            'width:min(520px,100%)', 'background:#fffaf3',
                            'border-radius:18px', 'padding:28px',
                            'box-shadow:0 22px 70px rgba(0,0,0,.28)',
                            'color:#4b260f', 'font-family:inherit'
                        ].join(';');
                        panel.innerHTML = `
                            <div style="font-size:22px;font-weight:800;line-height:1.45;margin-bottom:14px">
                                選択された時間帯は満席になりました
                            </div>
                            <div style="font-size:15px;line-height:1.9;color:#5f5148">
                                ご入力中に空席状況が変わったため、選択された時間帯をご予約いただけなくなりました。<br>
                                恐れ入りますが、別の時間帯をお選びください。
                            </div>
                            <button type="button" data-srs-slot-full-confirm style="margin-top:22px;width:100%;border:0;border-radius:12px;padding:14px 18px;background:#8b4513;color:#fff;font:inherit;font-weight:800;cursor:pointer">
                                時間を選び直す
                            </button>
                        `;
                        backdrop.appendChild(panel);
                        document.body.appendChild(backdrop);

                        const finish = () => {
                            backdrop.remove();
                            resolve();
                        };
                        panel.querySelector('[data-srs-slot-full-confirm]')?.addEventListener('click', finish, { once: true });
                    });

                const returnToTimeSelection = async () => {
                    // Wizard の既存「戻る」処理で STEP 2 に戻し、入力済み顧客情報は保持する。
                    for (let index = 0; index < 6; index += 1) {
                        const stepTwo = section.querySelector('[data-srs-step-panel="2"]');
                        if (stepTwo && !stepTwo.hidden) break;

                        const visiblePanel = Array.from(
                            section.querySelectorAll('[data-srs-step-panel]'),
                        ).find((panel) => panel.hidden === false);
                        const backButton = visiblePanel?.querySelector('[data-srs-back]');
                        if (!backButton) break;
                        backButton.click();
                        await new Promise((resolve) => window.setTimeout(resolve, 0));
                    }

                    // 失効した時刻だけを解除し、既存の空席照会に再判定させる。
                    state.setReservation({ time: '' });
                    const selectedDate = String(state.getState().reservation?.date || '');
                    if (selectedDate && window.SRS?.calendar?.loadSlots) {
                        await window.SRS.calendar.loadSlots(selectedDate);
                    }

                    section.querySelector('[data-srs-step-panel="2"]')?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                };

                const refreshAndValidateSelectedSlot = async (data) => {
                    const selectedTime = String(data.reservation.time || '');
                    const selectedDate = String(data.reservation.date || '');
                    if (!selectedDate || !selectedTime || !window.SRS?.calendar?.loadSlots) {
                        return true;
                    }

                    await window.SRS.calendar.loadSlots(selectedDate);
                    const refreshedTime = String(
                        state.getState().reservation?.time || '',
                    );
                    return refreshedTime === selectedTime;
                };

                submitButton.addEventListener(
                    "click",
                    async () => {
                        const currentState = state.getState();

                        if (
                            currentState.submission.isSubmitting ||
                            submitButton.dataset.submitted === "true"
                        ) {
                            return;
                        }

                        const clientRequestId =
                            state.getOrCreateClientRequestId();

                        const data = state.getState();

                        const payload = {
                            reservation_date: data.reservation.date,
                            reservation_time: data.reservation.time,
                            adults: data.guests.adults,
                            children: data.guests.children,
                            customer_name: data.customer.name,
                            phone: data.customer.phone,
                            email: data.customer.email,
                            language_code: "ja",
                            reservation_source: "shopify",
                            menu_request: data.customer.preorder,
                            customer_notes: data.customer.note,
                            client_request_id: clientRequestId,
                            turnstile_token: section.querySelector('[name="cf-turnstile-response"]')?.value || "",
                            items: [
                                {
                                    product_code: data.product.code,
                                    quantity: data.product.quantity || 1,
                                    drink_plan_added:
                                        data.product.drinkPlanSelected === true,
                                    drink_plan_quantity:
                                        data.product.drinkPlanSelected === true
                                            ? Number(data.guests.adults) +
                                              Number(data.guests.children)
                                            : null,
                                },
                            ],
                        };

                        const submitUrl = section.dataset.submitUrl;

                        if (!submitUrl) {
                            showError("送信先を確認できませんでした。");
                            return;
                        }

                        state.setSubmission({
                            isSubmitting: true,
                            error: "",
                        });

                        submitButton.disabled = true;
                        submitButton.textContent = "予約を送信しています…";

                        let completed = false;

                        try {
                            const selectedSlotStillAvailable =
                                await refreshAndValidateSelectedSlot(data);

                            if (!selectedSlotStillAvailable) {
                                state.setSubmission({
                                    isSubmitting: false,
                                    error: "",
                                });
                                await showSlotFullDialog();
                                await returnToTimeSelection();
                                return;
                            }

                            // 通信が切れた直後でも、同じ client_request_id で一度だけ
                            // 自動再確認する。RPC は冪等のため重複予約は作成されない。
                            let response = null;
                            let result = {};
                            let lastError = null;

                            for (let attempt = 0; attempt < 2; attempt += 1) {
                                try {
                                    response = await fetch(submitUrl, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-SRS-Request-ID": clientRequestId,
                                        },
                                        body: JSON.stringify(payload),
                                    });

                                    const responseText = await response.text();
                                    result = responseText
                                        ? JSON.parse(responseText)
                                        : {};

                                    if (response.ok && result.success === true) {
                                        lastError = null;
                                        break;
                                    }

                                    const requestError = new Error(
                                        result.error || "reservation_failed",
                                    );
                                    requestError.status = response.status;
                                    lastError = requestError;

                                    // 4xx は入力エラーなので再送しない。
                                    if (response.status >= 400 && response.status < 500) {
                                        break;
                                    }
                                } catch (requestError) {
                                    lastError = requestError;
                                }

                                if (attempt === 0) {
                                    await new Promise((resolve) =>
                                        window.setTimeout(resolve, 650),
                                    );
                                }
                            }

                            if (!response?.ok || result.success !== true) {
                                const error = lastError || new Error("reservation_failed");
                                error.status = Number(error.status || response?.status || 0);
                                throw error;
                            }

                            completed = true;

                            state.setSubmission({
                                isSubmitting: false,
                                reservationId:
                                    result.reservation?.reservation_id || "",
                                reservationNumber:
                                    result.reservation?.reservation_number || "",
                                duplicate: result.duplicate === true,
                                error: "",
                            });

                            const confirmationPanel = section.querySelector(
                                '[data-srs-step-panel="6"]',
                            );
                            const completePanel = section.querySelector(
                                '[data-srs-step-panel="7"]',
                            );
                            const progress = section.querySelector(
                                ".srs-reservation__progress",
                            );
                            const reservationNumber = section.querySelector(
                                "[data-reservation-number]",
                            );
                            const reservationMessage = section.querySelector(
                                "[data-reservation-message]",
                            );

                            if (confirmationPanel) confirmationPanel.hidden = true;
                            if (completePanel) completePanel.hidden = false;
                            if (progress) progress.hidden = true;

                            if (reservationNumber) {
                                reservationNumber.textContent =
                                    result.reservation?.reservation_number || "－";
                            }

                            if (reservationMessage) {
                                if (result.duplicate === true) {
                                    reservationMessage.textContent =
                                        "通信の再試行により、すでに受け付け済みのご予約を表示しています。重複予約は作成されていません。";
                                } else if (data.customer.email.trim()) {
                                    reservationMessage.textContent =
                                        "ご予約を承りました。確認メールは順次送信されます。届かない場合も、予約番号をお控えください。";
                                } else {
                                    reservationMessage.textContent =
                                        "ご予約を承りました。確認が必要な場合は、店舗よりお電話することがあります。";
                                }
                            }

                            submitButton.dataset.submitted = "true";
                            submitButton.textContent = "予約受付済み";

                            completePanel?.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });
                        } catch (error) {
                            if (window.turnstile) window.turnstile.reset();
                            console.error("Reservation submit failed:", error);

                            const status = Number(error?.status || 0);
                            const errorCode = String(error?.message || "");

                            if (errorCode === "slot_full") {
                                state.setSubmission({
                                    isSubmitting: false,
                                    error: "",
                                });
                                await showSlotFullDialog();
                                await returnToTimeSelection();
                                return;
                            }

                            const deterministicClientError =
                                status >= 400 && status < 500;

                            const message = deterministicClientError
                                ? "予約内容を確認できませんでした。日時や人数をご確認のうえ、もう一度お試しください。"
                                : "通信結果を確認できませんでした。同じ内容のまま、もう一度お試しください。同じ受付番号を使用するため、重複予約にはなりません。";

                            state.setSubmission({
                                isSubmitting: false,
                                error: message,
                            });

                            showError(message);
                        } finally {
                            if (!completed) {
                                submitButton.disabled = false;
                                submitButton.textContent = "予約を確定する";
                            }
                        }
                    },
                );
            };

                

  const initializeWizard = (section) => {
    const WizardClass =
      window.SRS?.ReservationWizard;

    const state = getStateManager();

    if (!WizardClass || !state) {
      console.error(
        "SRS state or wizard is unavailable.",
      );

      return null;
    }

    const wizard = new WizardClass(
      section,
      state,
    );

    wizard.init();

    return wizard;
  };

  const initializeSection = async (section) => {
    if (
      section.dataset.srsInitialized === "true"
    ) {
      return;
    }

    section.dataset.srsInitialized = "true";

    const sectionId =
      section.dataset.sectionId || "main";

    const productsUrl =
      section.dataset.productsUrl;

    const productList =
      section.querySelector(
        ".srs-reservation__product-list",
      );

    const nextButton =
      section.querySelector(
        ".srs-reservation__next-button",
      );

    if (
      !productsUrl ||
      !productList ||
      !nextButton
    ) {
      console.error(
        "SRS reservation elements are missing.",
      );

      return;
    }

    section.srsWizard =
      initializeWizard(section);

      const state = getStateManager();

        if (state) {
            state.subscribe(() => {
                renderReservationSummary(section);
                renderConfirmation(section);
            });
        }

    if (window.SRS?.calendar) {
        window.SRS.calendar.init(section);
    }

    initializeGuestSelection(section);
    initializeCustomerForm(section);
    initializeReservationSubmit(section);
    renderReservationSummary(section);
    renderConfirmation(section);

    try {
      const response = await fetch(productsUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(
          result.error ||
            "products_request_failed",
        );
      }

      if (
        !Array.isArray(result.products) ||
        result.products.length === 0
      ) {
        productList.innerHTML = `
          <div class="srs-reservation__error">
            現在ご予約いただけるプランはありません。
          </div>
        `;

        return;
      }

      productList.innerHTML = `
        <div class="srs-reservation__products">
          ${result.products
            .map((product, index) =>
              createProductHtml(
                product,
                sectionId,
                index,
              ),
            )
            .join("")}
        </div>
      `;

      productList.setAttribute(
        "aria-busy",
        "false",
      );

      initializeQuantityControls(productList);
        initializeDrinkPlanControls(productList);

        initializeProductSelection(
        productList,
        nextButton,
      );
    } catch (error) {
      console.error(
        "Failed to load SRS products:",
        error,
      );

      productList.setAttribute(
        "aria-busy",
        "false",
      );

      productList.innerHTML = `
        <div class="srs-reservation__error">
          ご予約プランを読み込めませんでした。<br>
          しばらくしてから、もう一度お試しください。
        </div>
      `;
    }
  };

  sections.forEach(initializeSection);

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section =
        event.target.querySelector(
          ".srs-reservation",
        );

      if (section) {
        initializeSection(section);
      }
    },
  );
})();

    